import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { Button, Modal, TabContent, TabPane } from "reactstrap";
import Loader from "../../../../loaders";

const tabs = [
    {
        title: "Roster Related Data",
        tabIndex: 0,
    },
    {
        title: "Recruitment Related Data",
        tabIndex: 1,
    },
];

export default function ReviewDialog(props)
{
    const {
        mergingData: {
            rosterList,
            jobOrderCandidateList,
        },
        onCancel,
        onSubmit
    } = props;

    const [activeTab, setActiveTab] = useState(0);
    const gridRosterRef = useRef();
    const gridLrfRef = useRef();
    const loadingOverlayComponent = useMemo(() => Loader, []);

    const defaultColumnDef = {
        filter: 'agTextColumnFilter',
        filterParams: {
            buttons: ['reset'],
            debounceMs: 200,
            excelMode: 'mac',
        },
        floatingFilter: true,
        floatingFilterComponentParams: {
            suppressFilterButton: true,
        },
        suppressMenu: true,
        resizable: true,
    };

    const rosterColumnDefs = [
        {
            headerName: "Project",
            field: "projectName",
            rowGroup: true,
            hide: true,
        },
        {
            headerName: "Dispatch Unit",
            field: "dispatchUnitName",
        },
        {
            headerName: "Slot No",
            field: "slotNo",
            width: 100,
        },
        {
            headerName: "Position",
            field: "positionName",
        },
        {
            headerName: "Shift",
            field: "shiftName",
            width: 100,
        },
        {
            headerName: "LRF Number",
            field: "recruitmentRequestNumber",
            width: 150,
        },
        {
            headerName: "Talent",
            field: "candidateName",
        },
        {
            headerName: "Start Date",
            field: "startDate",
            valueFormatter: (params) => {
                const { value } = params;
                return value ? moment(value).format('DD.MM.YYYY') : null;
            },
            width: 100,
        },
        {
            headerName: "End Date",
            field: "endDate",
            valueFormatter: (params) => {
                const { value } = params;
                return value ? moment(value).format('DD.MM.YYYY') : null;
            },
            width: 100,
        },
        {
            headerName: "Work Days",
            field: "workDays",
            width: 100,
        },
    ];

    const lrfColumnDefs = [
        {
            headerName: "Project",
            field: "projectName",
            rowGroup: true,
            hide: true,
            minWidth: 150,
            width: 150,
        },
        {
            headerName: "LRF Number",
            field: "recruitmentRequestNumber",
            minWidth: 150,
            width: 150,
        },
        {
            headerName: "Position",
            field: "positionName",
            minWidth: 150,
            width: 150,
        },
        {
            headerName: "Talent",
            field: "candidateName",
        },
        {
            headerName: "Start Date",
            field: "startDate",
            valueFormatter: (params) => {
                const { value } = params;
                return value ? moment(value).format('DD.MM.YYYY') : null;
            },
            minWidth: 150,
            width: 150,
        },
        {
            headerName: "End Date",
            field: "endDate",
            valueFormatter: (params) => {
                const { value } = params;
                return value ? moment(value).format('DD.MM.YYYY') : null;
            },
            minWidth: 150,
            width: 150,
        },
        {
            headerName: "Has Contract",
            field: "contractGenerated",
            valueFormatter: (params) => {
                const { value } = params;
                return value ? "Y" : "N";
            },
            minWidth: 150,
            width: 150,
        },
    ];

    const onRosterGridReady = useCallback(() => {
        if (!gridRosterRef?.current?.columnApi || rosterList?.length === 0)
            return;

        const allColumnIds = [];
        gridLrfRef.current.columnApi.getColumns().forEach((column) => {
            allColumnIds.push(column.getId());
        });
        gridLrfRef.current.columnApi.autoSizeColumns(allColumnIds, false);
    }, [rosterList, gridRosterRef]);

    const onLrfGridReady = useCallback(() => {
        if (!gridLrfRef?.current?.columnApi || jobOrderCandidateList?.length === 0)
            return;

        const allColumnIds = [];
        gridLrfRef.current.columnApi.getColumns().forEach((column) => {
            allColumnIds.push(column.getId());
        });
        gridLrfRef.current.columnApi.autoSizeColumns(allColumnIds, false);
    }, [jobOrderCandidateList, gridLrfRef]);

    return (
        <Modal
            isOpen={true}
            className="modal-xxl"
            modalClassName="db-example-modal-xl"
        >
            <div className="modal-header">
                <h5 className="modal-title">Project Merging Dialog</h5>
                <button
                    aria-label="Close"
                    className="close"
                    onClick={onCancel}
                    type="button"
                >
                    <span aria-hidden={true}><i className="fas fa-times" /></span>
                </button>
            </div>
            <div className="modal-body">
                <div className="w-100 border-bottom">
                {
                    tabs.map((t) => (
                        <Button
                            id={`project_merge_${t.tabIndex}`}
                            key={`project_merge_${t.tabIndex}`}
                            className="text-nowrap py-2 m-0 btn-nav-tab"
                            color="default"
                            active={activeTab === t.tabIndex}
                            onClick={(e) => {
                                e.preventDefault();
                                setActiveTab(t.tabIndex);
                            }}
                        >
                            {t.title}
                        </Button>
                    ))
                }
                </div>
                <TabContent className="mt-2" activeTab={activeTab}>
                    <TabPane tabId={0}>
                        <div className="ag-theme-alpine ag-grid" style={{ width: '100%', height: "70vh" }}>
                            <AgGridReact
                                ref={gridRosterRef}
                                gridOptions={null}
                                columnDefs={rosterColumnDefs}
                                defaultColDef={defaultColumnDef}
                                loadingOverlayComponent={loadingOverlayComponent}
                                //sideBar={sideBar}
                                suppressColumnVirtualisation={false}
                                suppressRowVirtualisation={false}
                                debounceVerticalScrollbar={false}
                                rowBuffer={20}
                                headerHeight={30}
                                groupHeaderHeight={30}
                                rowHeight={30}
                                floatingFiltersHeight={30}
                                onGridReady={() => onRosterGridReady()}
                                suppressDragLeaveHidesColumns={true}
                                suppressColumnMoveAnimation={true}
                                animateRows={false}
                                pagination={false}
                                rowClass={'ag-row-normal'}
                                rowData={rosterList}
                            />
                        </div>
                    </TabPane>
                    <TabPane tabId={1}>
                        <div className="ag-theme-alpine ag-grid" style={{ width: '100%', height: "70vh" }}>
                            <AgGridReact
                                ref={gridLrfRef}
                                gridOptions={null}
                                columnDefs={lrfColumnDefs}
                                defaultColDef={defaultColumnDef}
                                loadingOverlayComponent={loadingOverlayComponent}
                                //sideBar={sideBar}
                                suppressColumnVirtualisation={false}
                                suppressRowVirtualisation={false}
                                debounceVerticalScrollbar={false}
                                rowBuffer={20}
                                headerHeight={30}
                                groupHeaderHeight={30}
                                rowHeight={30}
                                floatingFiltersHeight={30}
                                // readOnlyEdit={true}
                                onGridReady={() => onLrfGridReady()}
                                suppressDragLeaveHidesColumns={true}
                                suppressColumnMoveAnimation={true}
                                animateRows={false}
                                pagination={false}
                                rowClass={'ag-row-normal'}
                                rowData={jobOrderCandidateList}
                            />
                        </div>
                    </TabPane>
                </TabContent>
            </div>
            <div
                className="modal-footer"
            >
                <Button
                    color="secondary"
                    onClick={onCancel}
                    type="button"
                >
                    Cancel
                </Button>
                <Button
                    color="default"
                    onClick={onSubmit}
                    type="button"
                >
                    Merge
                </Button>
            </div>
        </Modal>
    );
}